export default __webpack_public_path__ + "static/media/No.1-2.539f0f78.jpg";